import React from 'react';
// import {Link} from 'react-router';
import Grid from 'material-ui/Grid';
import AppBar from 'material-ui/AppBar';
import Button from 'material-ui/Button';
import Input, {InputAdornment} from 'material-ui/Input';
import Typography from 'material-ui/Typography';
import Call from 'material-ui-icons/Call';
import Mail from 'material-ui-icons/Mail';
import IconButton from 'material-ui/IconButton';
import Visibility from 'material-ui-icons/Visibility';
import VisibilityOff from 'material-ui-icons/VisibilityOff';
import { CircularProgress } from 'material-ui/Progress';
import Tooltip from 'material-ui/Tooltip';
import 'react-select/dist/react-select.css';
import {withStyles} from 'material-ui/styles';
import {ToastContainer} from "react-toastr"
import ToastMessagejQuery from "react-toastr/lib/components/ToastMessage/ToastMessagejQuery";
import axios from "axios";
import * as host from "../../host/host";

const jQueryFactory = React.createFactory(ToastMessagejQuery);
const styles = theme => ({
    fontSizeDefault: {
        fontSize: '15px',
        border: '1px solid #beb7b7 ',
        borderRadius: '3px',
        color: '#273140 ',
        padding: '5px',
        marginBottom: '15px',
        [theme.breakpoints.up('md')]: {}
    },
    loginFormRoot: {
        padding: '0 40px 0 40px',
        // paddingLeft: '15px',
        // paddingRight: '15px',
        backgroundColor: '#F9F9F9',
        [theme.breakpoints.up('md')]: {
            minHeight: '100vh',
            boxShadow: '0 2px 6px 0 rgba(0,0,0,0.25), 0 4px 20px 0 rgba(0,0,0,0.15)'
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '100px !important'
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '120px !important'
        }
    },
    loginFormTextRoot: {
        //backgroundColor: '#009688',
        /*color: '#ffffff',*/
        [theme.breakpoints.up('md')]: {
            minHeight: '108vh',
            boxShadow: '0 2px 6px 0 rgba(0,0,0,0.25), 0 4px 20px 0 rgba(0,0,0,0.15)',
            marginTop: '50px',
            paddingTop: '50px'
        }
    },
    loginForm: {
        fontWeight: '500',
        [theme.breakpoints.up('md')]: {
            marginTop: '100px'
        },
        [theme.breakpoints.up('xl')]: {
            marginTop: '45%'
        }
    },
    loginText: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10%'
        }
    },
    appBar: {
        backgroundColor: '#273140',
        minHeight: '72px',
        padding: '10px 0'
    },
    appBarTitle: {
        color: '#fff',
        fontSize: '35px',
        fontWeight: '400',
        letterSpacing: '-1px',
        margin: '0 0 0 20px',
        cursor: 'pointer'
    },
    subTitle: {
        color: '#666',
        textAlign: 'center',
        fontSize: '15px',
        marginBottom: '30px',
        marginTop: '10px'
    },
    appBarDiv:{
        [theme.breakpoints.up('md')]: {
            display: 'inline-flex'
        },
    },
    appBarSubTitle:{
        fontSize: 17,
        color: '#fff',
        margin: '0px 20px',
        [theme.breakpoints.up('md')]: {
            fontSize: 20,
            margin: '10px 40px'
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
        },
    },
    image: {
        display: 'block',
        margin: '15px auto',
        width: '80%',
        marginTop: '10%',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '100px'
        }
        //verticalAlign: 'middle'
        /*position: 'absolute',
        top: '0',
        right: '-200px'*/
    },
    appBarFooter: {
        backgroundColor: '#273140',
        height: 'auto',
        bottom: '0',
        left: '0',
        top: 'auto',
        padding: '10px 0'
    },
    appBarFooterTitle: {
        color: '#fff',
        fontSize: '35px',
        fontWeight: '400',
        letterSpacing: '-1px',
        margin: '0 0 0 20px',
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center'
        }
    },
    footerGrid:{
        marginTop: '10px'
    },
    footerInfo:{
        color: '#fff',
        fontSize: '16px',
        fontWeight: '200',
        letterSpacing: '-1px',
        textAlign: 'center',
        margin: '0 10px 10px 0'
    },
    footerText:{
        fontSize: '14px',
        margin: '10px 0 0 20px',
        color: 'rgb(102, 102, 102)',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center'
        }
    },
    callIcon:{
        padding: '9px 5px 0 0'
    },
    mailIcon:{
        padding: '9px 5px 0 0'
    },
    fullWidthButton: {
        marginTop: theme.spacing.unit,
        width: '100%',
        height: '50px',
        backgroundColor: '#1080f2 !important',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        borderRadius: '3px',
        fontSize: '14px',
        fontWeight: '700'
    },
    tooltipError:{
        height: '30px',
        fontSize: '13px',
        margin: '0',
        marginTop: '3px',
        backgroundColor: '#EF5350',
        borderColor: '#EF5350'
    }
});

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.formSubmit = this.formSubmit.bind(this);
        this.addErrorAlert = this.addErrorAlert.bind(this);
        this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
        this.onKeyPressed = this.onKeyPressed.bind(this);

        this.state = {
            email: '',
            password: '',
            showPassword: false,
            openErrorForEmail: false,
            openErrorForPass: false,
            loginError: false,
            buttonLoader: false,
            statusError: ''
        };
    }

    componentDidMount() {
        const _this = this;
        console.log('componentDidMount Login');
        if (localStorage.getItem("finMapAdminToken")) {
           // localStorage.removeItem("finMapAdminToken");
            _this.props.logOutHandler();
        }

        if (_this.props.login_value) {
            console.log(_this.props.login_value);
            _this.setState({
                email: _this.props.login_value
            });
        }
    }

    handleClickShowPassword() {
        const _this = this;
        this.setState({
            showPassword: !_this.state.showPassword
        });
    }

    handleEmailChange(event) {
        this.setState({
            email: event.target.value,
            openErrorForEmail: false,
            loginError: false
        });
    }

    handlePasswordChange(event) {
        this.setState({
            password: event.target.value,
            openErrorForPass: false
        });
    }

    onKeyPressed(event){
        const _this = this;
        if(event.key === 'Enter') {
            _this.formSubmit();
        }
    }

    formSubmit() {
        const _this = this;
        if (!_this.state.email || !_this.state.password) {
            !_this.state.email ?
                _this.setState({
                    openErrorForEmail: true
                }) : null;
            !_this.state.password ?
                _this.setState({
                    openErrorForPass: true
                }) : null;
            // _this.addErrorAlert("Ошибка!", "Заполните все поля.");
        }
        else {
            let data = {
                password: _this.state.password,
                email: _this.state.email
            };
            _this.setState({
                buttonLoader: true
            });
            axios({
                url: host.url + '/admin/login',
                method: 'post',
                data: data
            }).then(function (response) {
                console.log('login', response);
                localStorage.setItem('finMapAdminToken', response.data.token);
                _this.props.logInHandler(response);
            }).catch(function (error) {
                if (error) {
                    console.log('login', error);
                    if(error.response.status === 404){
                        _this.setState({
                            loginError: true,
                            openErrorForEmail: true,
                            buttonLoader: false,
                            statusError: error.response.status
                        });
                    }
                    else if(error.response.status === 401){
                        _this.setState({
                            loginError: true,
                            openErrorForPass: true,
                            buttonLoader: false,
                            statusError: error.response.status
                        });
                    }
                }
            });
        }
    }

    addErrorAlert(titleError, messageError) {
        this.refs.toastrContainer.error(
            messageError,
            titleError,
            {
                timeOut: 3000,
                extendedTimeOut: 1000,
                closeButton: true
            });
    }

    render() {
        const _this = this;
        const {classes} = this.props;
        return (
            <Grid container spacing={0}
                  onKeyDown={_this.onKeyPressed}
                  tabIndex="0"
                  // style={{height:'calc(100vh + 216px)'}}
            >
                <AppBar position="fixed"
                        className={classes.appBar}>
                    <div className={classes.appBarDiv}>
                        <Typography type="subheading" className={classes.appBarTitle} onClick={()=>{
                            window.open('https://finmap.online/', "_self");
                            //browserHistory.push('https://finmap.online/');
                        }}>
                            FINMAP
                        </Typography>
                        <Typography type="subheading" className={classes.appBarSubTitle}>
                            Сервис финансово-управленческого учета для бизнеса
                        </Typography>
                    </div>
                </AppBar>
                <Grid item xs={12} md={4} className={classes.loginFormRoot}>
                    <h1 style={{textAlign: 'center'}} className={classes.loginForm}>Вход в систему</h1>
                    <Typography type="subheading" className={classes.subTitle}>
                        Финансовая аналитика, остатки на счетах, бюджетирование и управление доступами - удобный интерфейс в одном приложении
                    </Typography>
                    <Tooltip
                        // title={(_this.state.loginError) ? 'Ошибка входа в систему' : 'Заполните поле'}
                        title={(!_this.state.email) ? 'Заполните поле' : (_this.state.statusError === 404) ? 'Такой логин не найден. Возможно вы хотите зарегистироваться?' : 'Ошибка входа в систему'}
                        enterDelay={300}
                        leaveDelay={300}
                        open={_this.state.openErrorForEmail}
                        placement="top"
                        disableTriggerFocus ={true}
                        disableTriggerHover= {true}
                        disableTriggerTouch={true}
                        classes={{tooltip: classes.tooltipError}}
                    >
                        <Input
                            style={(_this.state.openErrorForEmail) ? {borderColor:'#EF5350'} : null}
                            className={classes.fontSizeDefault}
                            type="text"
                            value={_this.state.email}
                            //onChange={_this.handleEmailChange}
                            onChange={(event)=>{
                                _this.handleEmailChange(event);
                                _this.props.handleLoginValueChange(event);
                            }}
                            placeholder='Email'
                            fullWidth={true}
                            disableUnderline={true}
                        />
                    </Tooltip>
                    <Tooltip
                        // title='Заполните поле'
                        title={(!_this.state.password) ? 'Заполните поле' : (_this.state.statusError === 401) ? 'Неверный пароль' : ''}
                        enterDelay={300}
                        leaveDelay={300}
                        open={_this.state.openErrorForPass}
                        placement="top"
                        disableTriggerFocus ={true}
                        disableTriggerHover= {true}
                        disableTriggerTouch={true}
                        classes={{tooltip: classes.tooltipError}}
                    >
                        <Input
                            style={(_this.state.openErrorForPass) ? {borderColor:'#EF5350'} : null}
                            className={classes.fontSizeDefault}
                            type={_this.state.showPassword ? 'text' : 'password'}
                            value={_this.state.password}
                            onChange={_this.handlePasswordChange}
                            placeholder='Пароль'
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton style={{height: '24px'}}
                                                onClick={_this.handleClickShowPassword}
                                    >
                                        {_this.state.showPassword ? <VisibilityOff/> : <Visibility/>}
                                    </IconButton>
                                </InputAdornment>
                            }
                            fullWidth={true}
                            disableUnderline={true}
                        />
                    </Tooltip>
                    <ToastContainer
                        ref="toastrContainer"
                        toastMessageFactory={jQueryFactory}
                        className="toast-top-center animated"/>
                    <Button raised color="primary"
                            aria-label="ПРОДОЛЖИТЬ"
                            className={classes.fullWidthButton}
                            onClick={_this.formSubmit}>
                        {(!_this.state.buttonLoader) ?
                            <div>ВОЙТИ</div> :
                            <CircularProgress className={classes.progress}
                                              style={{color: 'white'}}
                                              size={30}
                                              thickness={5}/>
                        }
                    </Button>
                </Grid>
                <Grid item xs={12} md={8} className={classes.loginFormTextRoot}>
                    <img src="../../images/FINMAP_desktop.jpg" alt="" className={classes.image}/>
                </Grid>
                <AppBar position="static" className={classes.appBarFooter}>
                    <Grid container spacing={0} className={classes.footerGrid}>
                        <Grid item xs={12} sm={6}>
                            <Typography type="subheading" className={classes.appBarFooterTitle} onClick={()=>{
                                window.open('https://finmap.online/', "_self");
                            }}>
                                FINMAP
                            </Typography>
                            <Typography type="subheading" className={classes.footerText}>
                                Делигируйте внесение финансов сотрудникам, а себе оставьте аналитику и принятие решений
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography className={classes.footerInfo}>
                                <Call className={classes.callIcon} />
                                +380-93-878-77-11
                            </Typography>
                            <Typography className={classes.footerInfo}>
                                <Mail className={classes.mailIcon}/>
                                info.businesslabs@gmail.com
                            </Typography>
                        </Grid>
                    </Grid>
                </AppBar>
            </Grid>
        );
    }
}

export default withStyles(styles, {withTheme: true})(Login);


// WEBPACK FOOTER //
// ./src/components/auth/Login.js